(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-information"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    const informationItems = document.querySelectorAll('.information-item');
    const informationTabs = document.querySelectorAll('.custom-product-information-tab');

    function activateTab(id){
        informationItems.forEach((item) => {
            item.removeAttribute('active');
        });
        informationTabs.forEach((tab) => {
            tab.removeAttribute('active');
        });
        document.querySelector(`.information-item[data-id="${id}"]`).setAttribute('active', '');
        document.querySelector(`.custom-product-information-tab[data-id="${id}"]`).setAttribute('active', '');

        // scroll to information-item element only on mobile 
        if(window.innerWidth <= 768) {
            try{
                setTimeout(() => {
                    const element = document.querySelector(`.information-item[data-id="${id}"]`);
                    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                }, 500);
            } catch(e) {}
        }
    }

    informationItems.forEach((item) => {
        item.addEventListener('click', () => {
            activateTab(item.getAttribute('data-id'));
        });
    });

    informationTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            activateTab(tab.getAttribute('data-id'));
        });
    });
});

  } catch(e) { console.error(e); }
})();
})();
